module.exports = __webpack_public_path__ + "static/media/java-logo.9a169d9b.png";